import { render, staticRenderFns } from "./VideosV2Accordian.vue?vue&type=template&id=813edf7a"
import script from "./VideosV2Accordian.vue?vue&type=script&lang=js"
export * from "./VideosV2Accordian.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports